export const lightTheme = {
  name: "light",
  body: "#FDFDFD",
  text: "#174372",
  toggleBorder: "#FFF",
  background: "#174372",
  lightsaber: "obi-wan",
  mainTitleColor: "#174372",
  mainTextColor: "black",
  mainLinkColor: "#174372",
  mainLinkHover: "#007eff",
  myInfoBarColor: "#174372",
  emailTextClass: "text-[#1da1f2] hover:text-[#007eff]",
  emailLineBg: "bg-1da1f2",
  projectDescriptionBg: "#9BC1EA",
  classForNav: "",
  hamburguerMenuIconColor: "#174372",
  menuBg: "#dcdcdc",
  themeIcon: "#174372",
};
export const darkTheme = {
  name: "dark",
  footer_bg: "red",
  text: "black",
  lightsaber: "yoda",
  mainTitleColor: "#14213d",
  mainTextColor: "#131417",
  mainLinkColor: "#D1FAE5",
  mainLinkHover: "rgb(21 255 134)",
  myInfoBarColor: "rgb(135,220,90)",
  emailTextClass: "text-green-100 hover:text-green-200 ",
  emailLineBg: "bg-green-100",
  projectDescriptionBg: "#4d4d83",
  classForNav: "",
  hamburguerMenuIconColor: "rgba(209, 250, 229, var(--tw-text-opacity))",
  menuBg: "#2c2c2c",
  themeIcon: "#D1FAE5",
  //   toggleBorder: "#6B8096",
  //   background: "#999",
};
